<div class="loading_overlay rounded" *ngIf="showSpinner">
    <app-loader></app-loader>
</div>
<div class="container-fluid">
    <div class="row">
        <div *ngIf="overdueTasks.length > 0 && showNotOnTrack" class="col">
                <div class="row">
                    <h6 class="track-titles">{{ 'projectuserview.notontrack' | trans }}</h6>
                </div>
                <app-projecttask *ngFor="let t of overdueTasks" [userview]="true" [commentsList]="" [projectCustomerMembers]="" [projectMembers]="" [task]="t"></app-projecttask>
                                    <!--THIS SHOULD GO TO PROJECT!!! DELETE ME WHEN DONE-->
                                    <!---Project in question should be replaced with the "{currentprojecttitle}" value  -->
                                    <!---<span matTooltip="Go to 'Project in question" matTooltipPosition="above" matTooltipShowDelay="500" style="margin-right: 10px;" class="material-icons project_launch_icon_button cursor-pointer">
                                        launch
                                        </span>-->
                                        <!---(click) doesnt work here it just unfolds and folds again-->
                                    <!---<span (click)="assignmenttoggle()" matTooltip="Mark task as done" matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons project_launch_icon_button cursor-pointer">
                                        assignment_turned_in
                                        </span>-->
        </div>
    </div>
    <div class="row">
        <div *ngIf="dueTasks.length > 0 && showAlmost" class="col">
            <div class="row">
                <h6 class="track-titles">{{ 'projectuserview.duetoday' | trans }}</h6>
            </div>
            <app-projecttask *ngFor="let t of dueTasks" [userview]="true" [commentsList]="" [projectCustomerMembers]="" [projectMembers]="" [task]="t"></app-projecttask>
        </div>
    </div>
    <div class="row">
        <div *ngIf="upcomingTasks.length > 0 && showOnTrack" class="col">
            <div class="row">
                <h6 class="track-titles">{{ 'projectuserview.upcomingtasks' | trans }}</h6>
            </div>
                <app-projecttask *ngFor="let t of upcomingTasks" [userview]="true" [commentsList]="" [projectCustomerMembers]="" [projectMembers]="" [task]="t"></app-projecttask>
        </div>
    </div>
  
</div>
